import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaBookmark, FaArrowRight } from 'react-icons/fa';
import ProxyLogo from './Styles/proxy.png';
import SafeguardLogo from './Styles/safeguard.png';
import ParcelLogo from './Styles/parcel.png';
import TandaRoscaLogo from './Styles/tandarosca.png';
import './Styles/Case.scss';

const caseStudiesData = [
  {
    id: 'proxy',
    title: 'Proxy',
    path: '/proxy',
    logo: ProxyLogo,
    category: 'UI/UX & Frontend Architecture',
    description: 'A deep dive into building modular, responsive components and optimizing web application performance.',
  },
  {
    id: 'safeguard',
    title: 'Safeguard',
    path: '/safeguard',
    logo: SafeguardLogo,
    category: 'Security & User Verification',
    description: 'Designing intuitive security workflows, authentication mechanics, and clean interface structures.',
  },
  {
    id: 'parcel',
    title: 'Parcel',
    path: '/parcel',
    logo: ParcelLogo,
    category: 'Logistics & Tracking Dashboard',
    description: 'Streamlining package tracking and status updates through an accessible, data-rich user interface.',
  },
  {
    id: 'tandarosca',
    title: 'TandaRosca',
    path: '/tandarosca',
    logo: TandaRoscaLogo,
    category: 'Fintech & Peer Savings Platform',
    description: 'Exploring peer-to-peer financial features, trust building, and modern UI patterns for savings groups.',
  },
];

const Case = () => {
  return (
    <main className="case-studies-container">
      {/* Header Section */}
      <section className="case-header">
        <span className="section-badge">
          <FaBookmark /> DEEP DIVES
        </span>
        <h1 className="headline">
          Case <span className="gradient-text">Studies</span>
        </h1>
        <p className="case-description">
          Detailed breakdowns of product design choices, technical hurdles, and step-by-step problem-solving across my projects.
        </p>
      </section>

      {/* Grid Section */}
      <section className="case-grid">
        {caseStudiesData.map((item) => (
          <NavLink to={item.path} key={item.id} className="case-card">
            <div className="card-top">
              <div className="logo-wrapper">
                <img src={item.logo} className="logo" alt={`${item.title} logo`} />
              </div>
              <span className="case-badge">{item.category}</span>
            </div>

            <div className="card-content">
              <h2 className="case-title">{item.title}</h2>
              <p className="case-summary">{item.description}</p>
            </div>

            <div className="card-footer">
              <span className="read-more">Read Full Case Study</span>
              <FaArrowRight className="arrow-icon" />
            </div>
          </NavLink>
        ))}
      </section>
    </main>
  );
};

export default Case;